/**
 * The microphone, asked for once (owner, 2026-10-14: «دسترسی‌ها یک‌بار تأیید
 * گرفته بشن و دائم باشه؛ هر بار نیاز به دسترسی به میکروفون نباشه»).
 *
 * There is no card of ours before the browser's prompt (owner, 2026-10-14:
 * «جملات اضافه و توضیحی نمیخوام توی صفحه») — the first tap on the microphone
 * is the prompt. What keeps it from asking again is lib/micStream.js (one
 * stream for the app); this only says when the button cannot be offered.
 */

/**
 * What the practice page shows where the microphone button goes.
 * - `permission`: the browser's answer — 'granted' | 'prompt' | 'denied', or
 *   'unknown' where `navigator.permissions` cannot be asked about the
 *   microphone (Firefox, older Safari).
 * - `errorCode`: what the last getUserMedia said ('denied' | 'unavailable' | null).
 *
 * The browser's live answer outranks a refusal remembered from an earlier tap:
 * a prompt closed without choosing leaves it at 'prompt' (the next tap asks
 * again), and a site unblocked in the browser's settings turns 'granted'.
 */
export function micView({ permission = 'unknown', errorCode = null } = {}) {
  if (errorCode === 'unavailable') return 'unavailable'
  if (permission === 'denied') return 'denied'
  if (errorCode === 'denied' && permission === 'unknown') return 'denied'
  return 'ready'
}

/**
 * The browser's PermissionStatus for the microphone, or null where it
 * cannot be asked (no Permissions API, or a browser that throws on the
 * 'microphone' name). Never throws.
 */
export async function queryMicPermission(permissions = globalThis.navigator?.permissions) {
  if (!permissions?.query) return null
  try {
    return await permissions.query({ name: 'microphone' })
  } catch {
    return null
  }
}
